import React from 'react';
import {useDispatch} from 'react-redux';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {farmOptions} from '../../../constants';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';

interface IRentBottomsheet {
  openRentBottomsheet: boolean;
  setOpenRentBottomsheet: React.Dispatch<React.SetStateAction<boolean>>;
}

function RentBottomsheet({
  openRentBottomsheet,
  setOpenRentBottomsheet,
}: IRentBottomsheet) {
  const dispatch = useDispatch();

  const handleItems = (value: string) => {
    setOpenRentBottomsheet(false);
    dispatch(addRegisterAdvertisement({rentBottomSheetData: value}));
  };

  return (
    <BottomSheet
      onDismiss={() => setOpenRentBottomsheet(false)}
      open={openRentBottomsheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col px-3 gap-4 pb-[35px] pt-[15px]">
        {farmOptions?.map(item => {
          return (
            <div key={item.id} className="flex flex-col w-full justify-center">
              <span onClick={() => handleItems(item.value)}>{item.title}</span>
            </div>
          );
        })}
      </div>
    </BottomSheet>
  );
}

export default RentBottomsheet;
